export const loadToken = () => {
  try {
    // It's also possible to use other local storage if it doesn't support localStorage
    const serializedState = localStorage.getItem('token');
    if (serializedState === null) {
      return undefined;
    } else {
      return JSON.parse(serializedState);
    }
  } catch (err) {
    // ...error handling
    return undefined;
  }
};
export const saveToken = (token) => {
  try {
    const serializedToken = JSON.stringify(token);
    localStorage.setItem('token', serializedToken);
  } catch (err) {
    // ...error handling
    console.log(err);
  }
};
